import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'capitalize'
})
export class CapitalizePipe implements PipeTransform {
    transform(value:string) : string{
        try {
            const valueParts = value?.split(' ') || [];
            const capitalizeValue = valueParts.map(valuePart => valuePart.charAt(0).toUpperCase() + valuePart.slice(1)).join(' ').trim();
            return capitalizeValue;
        } catch (error) {
            console.error('error in CapitalizePipe', error);
            return value;
        }
    }
}

